(function () {
    'use strict';

    /**
     * Handle global "debug mode" by setting a cookie.
     *
     */
    class Debug {
        static writeCookie() {
            document.cookie = "debug=true";
        }
        static isCookieSet() {
            var _a, _b;
            return !!((_b = (_a = document) === null || _a === void 0 ? void 0 : _a.cookie) === null || _b === void 0 ? void 0 : _b.match(/debug=true/i));
        }
        /**
         * Check if debug cookie was set.
         * Returns updated statusObject
         *
         * @return Object holding status information of debug mode.
         */
        static status() {
            if (Debug.isCookieSet()) {
                Debug.statusObject.activated = true;
                Debug.statusObject.text = "activated";
            }
            else {
                Debug.statusObject.activated = false;
                Debug.statusObject.text = "deactivated";
            }
            return Debug.statusObject;
        }
        /**
         * Activate "debug mode" by setting the debug cookie.
         *
         * @return {String} Status string.
         */
        static activate() {
            if (!Debug.status().activated) {
                Debug.writeCookie();
            }
            return Debug.status().text;
        }
        /**
         * Deactivate "debug mode" by deleting the debug cookie.
         *
         * @return {String} Status string.
         */
        static deactivate() {
            if (Debug.status().activated) {
                // https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Date/toGMTString
                document.cookie = `debug=; expires=${new Date().toUTCString()}`;
            }
            return Debug.status().text;
        }
        static warn(message) {
            if (Debug.status().activated) {
                // eslint-disable-next-line no-console
                console.warn(message);
            }
        }
    }
    Debug.statusObject = {
        activated: undefined,
        text: undefined
    };

    const { status, deactivate, activate, warn } = Debug;

    var Debug$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        activate: activate,
        deactivate: deactivate,
        status: status,
        warn: warn
    });

    // Export Debug functionality to global namespace.
    window.o_global = window.o_global || {};
    window.o_global.debug = window.o_global.debug || Debug$1;

}());
